<template>
  <div class="downloadContainer">
    <div
      class="downloadItem"
      v-for="item in downloadLists"
      :key="item.uploadId"
      @click="downloadItem(item)"
    >
      <i style="color: #0089ef;font-size: 14px" class="el-icon-paperclip" />
      <div class="downloadItemText">
        <span class="fileName">{{ item.fileName }}</span>
        <!--        <span-->
        <!--          v-if="!isEdit"-->
        <!--          @click="downloadItem(item)"-->
        <!--          class="downloadItemButton"-->
        <!--          >下载附件</span-->
        <!--        >-->
        <!--        <div v-else class="delete" @click="deleteDownload(item)">-->
        <!--          <i class="el-icon-close" />-->
        <!--        </div>-->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "detailDownload",
  props: {
    downloadLists: {
      type: Array,
      default: () => []
    },
    isEdit: {
      type: Boolean,
      default: () => false
    }
  },
  methods: {
    deleteDownload(item) {
      this.$emit("deleteDownload", item);
    },
    downloadItem(item) {
      this.$emit("downloadItem", item);

      // let openUrl = document.createElement("a");
      // openUrl.style.display = "none";
      // openUrl.href =
      //   `${addUrlPerFix(
      //     process.env.VUE_APP_BASE_URL
      //   )}/apis/sgmp/spc/download?downloadUrl=${item.fileUrl}&fileName=` +
      //   encodeURIComponent(item.fileName);
      // openUrl.setAttribute("download", item.fileName);
      // document.body.appendChild(openUrl);
      // openUrl.click();
    }
  }
};
</script>

<style lang="scss" scoped>
.downloadItem {
  display: flex;
  align-items: center;
  color: #0089ef;
  cursor: pointer;
  font-size: 13px;
  margin-bottom: 10px;
  .downloadItemText {
    display: flex;
    align-items: center;
    margin-left: 2px;
    overflow: hidden;
  }

  .fileName {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: calc(1300px - 80px);
    display: inline-block;
  }

  .downloadItemButton {
    color: #0089ef;
    font-size: 13px;
    margin-left: 10px;
    flex-shrink: 0;
    cursor: pointer;
  }
  .delete {
    width: 14px;
    height: 14px;
    background: #575b66;
    border-radius: 7px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    font-size: 12px;
    margin: 4px 0 0 10px;
    cursor: pointer;
    > i {
      margin-left: -1px;
    }
  }
}
</style>
